export const DEALER_MODE = 'DEALER_MODE';
export const GROUP_MODE = 'GROUP_MODE';
export const USER_MODE = 'USER_MODE';
export const ALL_MODE = 'ALL_MODE';

const LIBRARY_TYPE = {
  USER_MODE,
  DEALER_MODE,
  GROUP_MODE,
  ALL_MODE,
};

export const DEFAULT_PAGE_SIZE = 24;
export const LIBRARY_TYPES = Object.values(LIBRARY_TYPE);
